import * as actionTypes from './actionTypes';

const initialState = {
  isUploading: false,
  // Documents within active folder
  activeFolderDocumentIds: [],
  activeFolderDocumentsIsLoading: false,
  // Documents within active folder or any subfolder of the active folder
  activeFolderRecursiveDocumentIds: [],
  activeDocumentId: null,
  isUpdatePasswordMismatch: false,
  isUpdateInProgress: false,
  percentUpload: 0,
  isLoading: false,
  hasError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BY_ACTIVE_FOLDER:
      return {
        ...state,
        activeFolderDocumentsIsLoading: true,
      };
    case actionTypes.FETCH_BY_ACTIVE_FOLDER_SUCCESS:
      return {
        ...state,
        activeFolderDocumentsIsLoading: false,
        activeFolderDocumentIds: action.ids.map((id) => parseInt(id, 10)),
      };
    case actionTypes.FETCH_RECURSIVE_BY_FOLDER_PATH_SUCCESS:
      return {
        ...state,
        activeFolderRecursiveDocumentIds: action.ids.map((id) => parseInt(id, 10)),
      };
    // case actionTypes.UPLOAD_SUCCESS:
    //   return {
    //     ...state,
    //     activeFolderDocumentIds: [...state.activeFolderDocumentIds, ...action.ids],
    //   };
    case actionTypes.SET_ACTIVE_DOCUMENT_ID:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        activeDocumentId: parseInt(action.id, 10),
      };
    case actionTypes.FETCH:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
      };
    case actionTypes.UPDATE:
      return {
        ...state,
        isUpdateInProgress: true,
      };
    case actionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        isUpdatePasswordMismatch: false,
        isUpdateInProgress: false,
        // remove document from active folder doc list if it has been moved
        activeFolderDocumentIds: action.document.folder !== action.activeFolderId
          ? state.activeFolderDocumentIds.filter((id) => id !== action.document.id)
          : state.activeFolderDocumentIds,
        activeFolderRecursiveDocumentIds: action.document.folder !== action.activeFolderId
          ? state.activeFolderRecursiveDocumentIds.filter((id) => id !== action.document.id)
          : state.activeFolderRecursiveDocumentIds,
      };
    case actionTypes.UPDATE_PASSWORD_MISMATCH:
      return {
        ...state,
        isUpdateInProgress: false,
        isUpdatePasswordMismatch: true,
      };
    case actionTypes.CLONE_SUCCESS:
      return {
        ...state,
        activeFolderDocumentIds: [...state.activeFolderDocumentIds, action.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        activeFolderDocumentIds:
            state.activeFolderDocumentIds.filter((id) => id !== action.document.id),
        activeFolderRecursiveDocumentIds:
            state.activeFolderRecursiveDocumentIds.filter((id) => id !== action.document.id),
      };
    case actionTypes.SET_UPLOAD_PERCENTAGE:
      return {
        ...state,
        percentUpload: Math.floor(action.percent),
      };
    default:
      return state;
  }
};
